import React from 'react';
import { Tag } from '@ontruck/orc';

const t = {
  NON_CORE: 'RFQ',
};

const OrderCoreInfo = ({ isCore }) => {
  return (
    !isCore && (
      <Tag mLeft="XS" skin="modernRed" weight="bold">
        {t['NON_CORE']}
      </Tag>
    )
  );
};

export default OrderCoreInfo;
